import { render, staticRenderFns } from "./ContaAlternativa.vue?vue&type=template&id=8d3aa912"
import script from "./ContaAlternativa.vue?vue&type=script&lang=js"
export * from "./ContaAlternativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports